import React from 'react';
import './styles.scss';
import { Check, X } from 'react-bootstrap-icons';
import Spinner from 'react-bootstrap/Spinner';
import { SUBMIT_STATUS } from '../../../../../../helpers/constants';

export const SubmitButton = ({ onCancel, onSubmit, status, buttonText }) => {
  return (
    <div className="submit-btn-container">
      <button disabled={status === SUBMIT_STATUS.LOADING} className="cancel-btn" onClick={onCancel}>
        Back
      </button>
      <button
        disabled={status === SUBMIT_STATUS.LOADING}
        className={`submit-btn ${status === SUBMIT_STATUS.LOADING ? 'disabled' : ''}`}
        type="submit"
        onClick={onSubmit}
      >
        <p className="btn-text">{buttonText || 'Next'}</p>
        {status === SUBMIT_STATUS.FAILED ? (
          <X className="submit-btn-status-icon" />
        ) : status === SUBMIT_STATUS.LOADING ? (
          <Spinner animation="border" role="status" className="submit-btn-status-icon spinner" />
        ) : status === SUBMIT_STATUS.SUCCESS ? (
          <Check className="submit-btn-status-icon" />
        ) : null}
      </button>
    </div>
  );
};
